<template>
  <v-container>
    <v-layout grid-list-md>
      <v-flex md3> チーム </v-flex>
      <v-flex md3>
        <v-select
          :items="teamsArray"
          v-model="setting.team_name"
          :disabled="!CanI('EditUser')"
        />
      </v-flex>
    </v-layout>
    <v-layout grid-list-md>
      <v-flex md3> 勤務種別 </v-flex>
      <v-flex md3>
        <v-select
          :items="workTypesArray"
          v-model="setting.work_type"
          required
          :disabled="!CanI('EditUser')"
        />
      </v-flex>
      <v-flex md3 v-if="setting.work_type == '一般'">
        <v-checkbox
          v-model="setting.few_work_days"
          :label="`勤務日時少`"
          :disabled="!CanI('EditUser')"
        ></v-checkbox>
      </v-flex>
    </v-layout>
    <v-layout align-center justify-start row fill-height class="table-row">
      <v-flex md3>一日の標準時間</v-flex>
      <v-flex md9>
        <input-time
          :isBy10Minutes="true"
          v-model="setting.predefined_time"
        />
      </v-flex>
    </v-layout>
    <div v-if="setting.work_type == '一般'">
      <v-layout align-center justify-start row fill-height class="table-row">
        <v-flex md3>一週間の勤務日数</v-flex>
        <v-flex md1>
          <v-text-field
            v-model.number="setting.work_days_per_week"
            suffix="日"
            min="1"
            max="7"
            type="number"
            :disabled="!CanI('EditUser')"
          />
        </v-flex>
      </v-layout>

      <v-layout align-center justify-start row fill-height class="table-row">
        <v-flex md3>基本給</v-flex>
        <v-flex md3>
          <v-text-field
            v-model.number="setting.base_salary"
            suffix="円"
            min="0"
            type="number"
            required
          />
        </v-flex>
        <v-flex md3 offset-md1 v-if="CanI('EditUser')">
          <v-checkbox
            v-model="setting.is_joining_in_the_middle"
            :label="`月中入社`"
          ></v-checkbox>
        </v-flex>
      </v-layout>
      <v-layout
        align-center
        justify-start
        row
        fill-height
        class="table-row"
        v-if="setting.is_joining_in_the_middle"
      >
        <v-flex md3>契約上の基本給</v-flex>
        <v-flex md3>
          <v-text-field
            v-model.number="setting.monthly_base_salary"
            suffix="円"
            min="0"
            type="number"
            required
          />
        </v-flex>
      </v-layout>
    </div>

    <v-layout
      v-if="setting.work_type == '時給' || setting.work_type == 'アルバイト'"
      align-center
      justify-start
      row
      fill-height
      class="table-row"
    >
      <v-flex md3>時給</v-flex>
      <v-flex md3>
        <v-text-field
          v-model.number="setting.hourly_base_salary"
          suffix="円"
          min="0"
          type="number"
          required
        />
      </v-flex>
    </v-layout>
    <v-layout align-center justify-start row fill-height class="table-row">
      <v-flex md3>通勤種別</v-flex>
      <v-flex md6>
        <v-radio-group v-model="setting.commuting_allowance_type" row>
          <v-radio label="月額" value="月額"></v-radio>
          <v-radio label="日額" value="日額"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="setting.commuting_allowance_type != '日額'"
      align-center
      justify-start
      row
      fill-height
      class="table-row"
    >
      <v-flex md3>通勤費</v-flex>
      <v-flex md3>
        <v-text-field
          type="number"
          v-model.number="setting.commuting_allowance"
          suffix="円"
        />
      </v-flex>
    </v-layout>
    <v-layout
      v-else
      align-center
      justify-start
      row
      fill-height
      class="table-row"
    >
      <v-flex md3>通常通勤経路</v-flex>
      <v-flex md4>
        <v-text-field v-model="setting.daily_commuting_route" />
      </v-flex>
      <v-flex md1>通常通勤費</v-flex>
      <v-flex md2>
        <v-text-field
          type="number"
          v-model.number="setting.daily_commuting_allowance"
          suffix="円"
        />
      </v-flex>
    </v-layout>
    <v-layout align-center justify-start row fill-height class="table-row">
      <v-flex md3>健康保険料</v-flex>
      <v-flex md3>
        <v-text-field
          type="number"
          v-model.number="setting.kenko_insurance"
          suffix="円"
        />
      </v-flex>
    </v-layout>
    <v-layout align-center justify-start row fill-height class="table-row">
      <v-flex md3>厚生年金保険料</v-flex>
      <v-flex md3>
        <v-text-field
          type="number"
          v-model.number="setting.kouseinenkin_insurance"
          suffix="円"
        />
      </v-flex>
    </v-layout>
    <v-btn
      @click.stop="updateSetting"
      :disabled="readOnly"
      color="deep-orange"
      class="white--text"
      >更新</v-btn
    >
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import InputTime from "@/components/inputLargeTime";
import { workTypesArray, teamsArray } from "@/master/users.js";
export default {
  components: {
    InputTime,
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      workTypesArray: workTypesArray,
      teamsArray: teamsArray,
      setting: {},
    };
  },
  computed: {
    ...mapGetters("timesheet", ["owner"]),
    ...mapGetters("auth", ["CanI"]),
  },
  mounted() {
    this.setting = JSON.parse(JSON.stringify(this.owner));
    this.setting.work_days_per_week = this.setting.work_days_per_week || 5;
    console.log(this.setting);
  },
  methods: {
    updateSetting() {
      console.log("updateSetting", this.setting);
      this.updateTimesheetSetting(this.setting);
    },
    ...mapActions("timesheet", ["updateTimesheetSetting"]),
  },
};
</script>

<style lang="scss" scoped>
</style>